
export * from '@ms/utilities-guid/lib/index';
